
export const useHighlightWord = (word, text) => {

  return text.replace(word,`<strong>${word}</strong>`);
};